<template>
  <div>
    <el-card class="cardDiv">
      <div slot="header">
        <span>风控通知</span>
        <span><el-button type="text" @click="readAll" class="margl">查看所有消息 ({{ noticeNum }})</el-button></span>
      </div>
      <ul>
        <li v-for="(item,key) in noticeList" :key="key" class="serveNotice">
          <div class="circle"></div>
          <span class="content">
            <div class="uline" @click="toDetails(item)">商户{{ item.fMerchantName }}&nbsp;的风控审核</div>
            <div class="timeDiv">{{ item.fCreateTime }}</div>
          </span>
          <el-button type="text" class="checkBtn" @click="toDetails(item)">查看</el-button>
        </li>
      </ul>
    </el-card>
  </div>
</template>

<script>
import qs from 'qs'
import { riskOperFlows, updateReadState } from '@/api/home'
export default {
  name: 'NotReadNotice',
  data () {
    return {
      noticeNum: 100,
      noticeList: [],
      loading: false,
      pageNo: 1,
      pageSize: 10
    }
  },
  mounted () {
    this.getList()
  },
  computed: {
    notReadNum () {
      if (this.noticeNum <= 99) {
        return this.noticeNum
      } else {
        return '99+'
      }
    }
  },
  methods: {
    getList () {
      var data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        FReadStatus: 0
      }
      data = qs.stringify(data)
      riskOperFlows(data).then(data => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.noticeList = data.data.list
          this.noticeNum = data.data.totalCount
        }
      })
    },
    /**
             * @description 查看全部消息
             */
    readAll () {
      this.$router.push('/index/allNotice')
    },
    /**
             * @description 查看消息详情
             */
    toDetails (row) {
      var data = {
        flowId: row.fId
      }
      data = qs.stringify(data)
      updateReadState(data).then(data => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {

        }
      })
      this.$router.push('/Risk/RiskManage/checkDetails/' + row.fTicketNumber)
    },
    /**
             * @description 清空未读消息
             */
    clearNotRead () {
      this.$confirm('确定清空全部未读通知吗？（清空后仍可在全部通知中查看）', '提示', {}).then(() => {
        var data = {
          emptyMyMsg: 1
        }
        data = qs.stringify(data)
        updateReadState(data).then(data => {
          if (parseInt(data.error_code) !== 0) {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'success'
            })
            this.getList()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .cardDiv{
        min-height: 200px;
        max-height:500px;
        overflow-y: scroll;
    }
    .noticeTitle{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-decoration: underline;
        cursor: pointer;
        margin: 0;
    }
    .table{
        border: 1px solid #ebeef5;
    }
    .notRead{
        border: 1px solid #ebeef5;
        background: #f4f4f5;
        color: #606266;
        line-height: 40px;
        height: 40px;
        font-size: 14px;
        padding: 0 10px;
        float: left;
    }
    .rightDiv{
        float: right;
    }
    .allLink{
        color:#409EFF;
        text-decoration: underline;
        cursor: pointer;
    }
    .topDiv:after{
        clear: both;
        content: '';
        overflow: hidden;
        height: 0;
        display: block;
        visibility: hidden;
    }
    .noneText{
        margin-top: 50px;
        text-align: center;
        color:#606266;
        font-size: 14px;
    }
    .margl{
        margin-left:22px;
    }
    /deep/.el-card__header{
        padding:5px 20px;
    }
    .uline {
        cursor: pointer
    }
    .serveNotice {
        height:70px;
        width:1000px;
        font-size:14px;
        position: relative;
        background:rgba(246,249,255,1);
        border:1px solid rgba(231,239,255,1);
        border-radius:2px;
        margin-bottom:14px;
        .circle {
            display:inline-block;
            width:6px;
            height:6px;
            background:rgba(64,158,255,1);
            border-radius:50%;
            margin:0 15px;
            position:relative;
            top:20px
        }
        .content {
            display: inline-block;
            position: absolute;
            left:32px;
            top:20px
        }
        .checkBtn {
            position: absolute;
            right:108px;
            top:13px
        }
        .timeDiv {
            margin:5px
        }
    }
</style>
